import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { showError } from "redux/actions/ui";
import { useAppDispatch } from "hooks/redux";

import { StatusCode } from "api/protocols";
import { GetEmailTemplate } from "api/rpc/2024-04/facilityAdmin/facility/emailTemplate";

import Page from "components/page/Page";
import DataTable from "components/dataTable/DataTable";
import Card from "components/card/Card";
import { valueToString } from "helpers/Helpers";
import { useTranslation } from "react-i18next";
import Tabs from "components/tabs/Tabs";
import Callout from "components/callout/Callout";

export type TEmailTemplate = {
  id: number;
  facility_id: number;
  title: string;
  type: string;
  subject: string;
  content: string;
};

enum TemplateTab {
  All = 0,
  Manual = 1,
  Automated = 2,
}

export default function EmailTemplates() {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(TemplateTab.All);

  const [emailTemplates, setEmailTemplates] = useState(undefined);

  useEffect(() => {
    void loadTemplates();
  }, [selectedTab]);

  async function loadTemplates() {
    //loader 
    if (emailTemplates !== undefined) {
      setEmailTemplates(undefined);
    }
    const templateRes = await GetEmailTemplate({automated: selectedTab === TemplateTab.Manual ? false : selectedTab === TemplateTab.Automated ? true : undefined }, false);

    if (templateRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error loading email templates")));
      setEmailTemplates([]);
      return;
    }

    setEmailTemplates(templateRes.data);
  }

  const primaryAction = {
    content: t("New"),
    action: () => history.push("/admin/settings/email-template/new"),
  };

  return (
    <Page
      title={t("Email Templates")}
      narrow
      primaryAction={primaryAction}
    >
      <Tabs tabs={[{content: t("All")}, {content: t("Manual Templates")}, {content: t("Automated Templates")}]} selected={selectedTab} onSelect={tab => setSelectedTab(tab)} variant="underline"/>
        <br />
        {selectedTab === TemplateTab.Automated ? (
          <>
          <Callout type="primary" title={t("Editing automated emails affects live customer emails")} content={t("Templates are sent automatically and protected fields (booking code, date, time, etc) cannot be altered or deleted")}/>
          <br />
          </>
        ) : null}
        
      <Card>
        <Card.Section table={true}>
          <DataTable
            columns={[
              { label: t("Title") },
              { label: t("Type") },
            ]}
            loading={emailTemplates === undefined}
          >
            {emailTemplates?.map((template: TEmailTemplate, index: number) => {
              return (
                <tr
                  key={index}
                  onClick={() => history.push("/admin/settings/email-template/" + String(template.id))}
                  className="clickable"
                >
                  <td>{template.title}</td>
                  <td>{valueToString(template.type)}</td>
                </tr>
              );
            })}
          </DataTable>
        </Card.Section>
      </Card>
    </Page>
  );
}
